import ReferenceHero from '/react4xp/components/prototype/ReferenceHero'
import TextBlock from '/react4xp/components/prototype/TextBlock'

import type { ReferenceProps } from './types'

export default function Reference({
	title,
	customerLabel,
	customer,
	deliveryLabel,
	delivery,
	tags,
	image,
	ingress,
	content,
}: ReferenceProps) {
	return (
		<article>
			<ReferenceHero
				title={title}
				customerLabel={customerLabel}
				customer={customer}
				deliveryLabel={deliveryLabel}
				delivery={delivery}
				tags={tags}
				image={image}
				ingress={ingress}
			/>

			{content && <TextBlock items={content} />}
		</article>
	)
}
